import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';

/** A map centred on where this browser says it is; without its title, the map fills the whole tile. */
export const LOCATION_MAP_WIDGET: DashboardWidgetDefinition = {
  type: 'location-map',
  title: 'Dashboard.LocationMap.Title',
  description: "A map of this device's current location.",
  icon: 'my_location',
  loadComponent: () => import('./location-map-widget.component').then((m) => m.LocationMapWidgetComponent),
  frame: 'edge',
  titleControls: true,
  size: { default: { w: 8, h: 4 }, min: { w: 3, h: 3 } },
};
